import { GetCertificateOutput } from "@_types/certificates";
import { z } from "zod";
import { CourseSchema } from "../courses/Course.schema";

export const CourseByIdSchema = CourseSchema.pick({
  uuid: true,
});

export type GetCoursesInput = z.infer<typeof CourseByIdSchema>;
export type GetCoursesOutput = z.infer<typeof CourseSchema>;

export type GetCoursesConfigOutput = {
  certificate: GetCertificateOutput;
};
